import { createAction } from '@reduxjs/toolkit';

import { createAPIActions } from 'utils/common';

import type {
  RawWallPreviewUserRoom,
  WallPreviewImageLoadPayload,
  CreateUserRoomPOSTData,
} from './wall_preview_rooms.types';

const fetchUserRooms = createAPIActions<void, RawWallPreviewUserRoom[]>(
  'wallPreview',
  'fetchUserRooms'
);

const wallPreviewImageLoad = {
  fulfilled: createAction<WallPreviewImageLoadPayload>('wallPreview/imageLoad/fulfilled'),
};

const createUserRooms = createAPIActions<CreateUserRoomPOSTData[], RawWallPreviewUserRoom[]>(
  'wallPreview',
  'createUserRooms'
);

const saveUserRooms = createAPIActions<void, RawWallPreviewUserRoom[]>(
  'wallPreview',
  'saveUserRooms'
);

const deleteUserRoom = createAPIActions<number, number>('wallPreview', 'deleteUserRoom');

export default {
  fetchUserRooms,
  wallPreviewImageLoad,
  createUserRooms,
  saveUserRooms,
  deleteUserRoom,
};
